<template>
  <v-container fluid grid-list-lg>

      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title>Campaigns </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-row justify="end">

          <v-col class="shrink">
            <v-btn-toggle small rounded v-model="toggleChange">
              <v-btn small>
                <span class="hidden-sm-and-down">Published</span>
              </v-btn>
              <v-btn small>
                <span class="hidden-sm-and-down">Not Published</span>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col class="shrink">
            <v-btn v-if="checkRightStatus(73)" @click="add" outlined rounded raised small>
              <v-icon small>add</v-icon> New
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-row>
        <v-col v-for="(item, index) in campaigns" :key="index">
          <v-card class="mx-auto my-12" max-width="500" outlined>


            <v-img height="250" :src="item.imageUrl"></v-img>

            <v-card-title>{{ item.name }}
              <v-chip class="text-capitalize ml-2" v-if="item.isActive" small color="#1976D2"
              dark rounded>Published</v-chip>
            </v-card-title> 
            

            <v-card-text>
              <v-row align="center" class="mx-0">
                Code: {{ item.code }}
                <!-- <v-rating :value="4.5" color="amber" dense half-increments readonly size="14"></v-rating>

                <div class="grey--text ms-4">
                  4.5 (413)
                </div> -->
              </v-row>

              <div class="my-4 text-subtitle-1">
                Product: {{ item.Product.name }}
              </div>
              <div class="my-4 text-subtitle-1 text-decoration-underline blue--text pointer" @click="openCampaignLink(item)">
                {{ item.link }}
              </div>

              <div> {{ stripHTML(item.description) }}</div>
              <!-- <div><p v-html="item.description"></p></div> -->
            </v-card-text>

            <v-divider class="mx-4"></v-divider>



            <v-card-text>
              place holder
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" v-if="checkRightStatus(75)" text @click="editCampaign(item)">
                <v-icon left>
                  mdi-pencil
                </v-icon>
                Edit
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="red" v-if="checkRightStatus(76)" text @click="deleteCampaign(item)">
                <v-icon left>
                  delete
                </v-icon>
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>



  </v-container>
</template>

<script>
import campaignService from "../service";
import { mapGetters } from "vuex";

export default {
  name: "campaign-list",
  data() {
    return {
      headers: [
        {
          text: this.$t('labels.image'),
          value: 'imageUrl',
          sortable: false,
        },
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "code",
          align: "center",
          value: "code",
          sortable: true,
        },
        {
          text: "Category",
          align: "left",
          value: "Product.name",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      campaigns: [],
      toggleChange: '',
      search: null,
      loading: true,
      page: 1,
      showNonActiveOnly: false,
      showActiveOnly: false,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Campaign List";
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  watch: {
    toggleChange(val) {
      if (val === 0) {
        this.showActiveOnly = true
        this.showNonActiveOnly = false
      } else if (val === 1) {
        this.showNonActiveOnly = true
        this.showActiveOnly = false
      } else {
        this.showNonActiveOnly = false
        this.showActiveOnly = false
      }
      this.getList()
    },
  },
  methods: {
    add() {
      this.$router.push({
        path: '/campaign/create',
      });
    },
    getList() {
      this.loading = true;
      (this.editDialog = false);
      let where = {}
      where.showNonActiveOnly = this.showNonActiveOnly
      where.showActiveOnly = this.showActiveOnly
      return campaignService.getAll(where).then((response) => {
        console.log('responseresponse', response)
        this.loading = false;
        this.campaigns = response.data;
        this.campaigns.map(campaign => {
          campaign.link = `${process.env.VUE_APP_FE_URL}/go/${campaign.code}`;
        })
        return response;
      });
    },
    editCampaign(campaign) {
      this.$router.push({ path: `/campaign/${campaign.id}/edit` });
    },
    openCampaignLink(val) {
      let routeData = this.$router.resolve({
        path: `/go/${val.code}`,
      });
      window.open(routeData.href, "_blank");
    },
    escapeHTML(html) {
      return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    stripHTML(html) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      return tempElement.textContent || tempElement.innerText || '';
    },
    deleteCampaign(campaign) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          campaignService.delete(campaign.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Campaign has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
